const getLangFromURLParam = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('lang') || '';
};

export default getLangFromURLParam;
